import {put,takeEvery} from 'redux-saga/dist/redux-saga-effects-npm-proxy.esm';

import {TYPES as TIMELINE_COMMENT_TYPE} from '../creators/timeline.comment';

export function* createSuccess(action) {
    try {
        yield put({type: "TIMELINE_COMMENTS_ADD", data : action.payload});
        yield put({type: "USER_TIMELINES_INCREMENT_COMMENT", data : action.payload});
    } catch (error) {

    }
}

export function* deleteSuccess(action) {
    try {
        yield put({type: "TIMELINE_COMMENTS_DELETE", data : action.payload});
        yield put({type: "USER_TIMELINES_DECREMENT_COMMENT", data : action.payload});
    } catch (error) {

    }
}

export function* updateSuccess(action) {
    try {
        yield put({type: "TIMELINE_COMMENTS_UPDATE", data : action.payload});
    } catch (error) {

    }
}

export function* watchTimelineComment() {
    yield takeEvery(TIMELINE_COMMENT_TYPE.CREATE_SUCCESS, createSuccess);
    yield takeEvery(TIMELINE_COMMENT_TYPE.DELETE_SUCCESS, deleteSuccess);
    yield takeEvery(TIMELINE_COMMENT_TYPE.UPDATE_SUCCESS, updateSuccess);
}

export default watchTimelineComment;

